<template>
  <div class="field">
    <label class="field__label" :for="name" :class="{ active: visible }">{{ label }}</label>
    <VueDatePicker 
      v-model="innerValue"
      :flow="['year', 'month', 'calendar']"
      locale="nl"
      format="dd-MM-yyyy"
      preview-format="dd-MM-yyyy"
      :max-date="new Date()"
      start-date="2000-01-01"
      :placeholder="label"
      :hide-input-icon="true"
      :text-input="true"
      :enable-time-picker="false"
      auto-apply
    >
    </VueDatePicker>
    <template v-if="validator?.$errors">
      <p v-for="(error, i) in validator?.$errors" :key="i" class="field__error">
        {{ error.$message }}
      </p>
    </template>
  </div>
</template>

<script lang="ts" setup>
import VueDatePicker from '@vuepic/vue-datepicker';
import { BaseValidation } from '@vuelidate/core';

import '@vuepic/vue-datepicker/dist/main.css';

const textInputOptions = {
  format: 'dd-MM-yyyy',
  selectOnFocus: true
};

const props = defineProps({
  modelValue: {
    type: [String, Date] as PropType<string|Date>,
    default: ''
  },
  name: {
    type: String as PropType<string>,
    default: ''
  },
  label: {
    type: String as PropType<string>,
    default: ''
  },
  validator: {
    type: Object as PropType<BaseValidation>
  }
});

const emit = defineEmits(['update:modelValue']);

const innerValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const focused = ref<boolean>(false);
const visible = computed<boolean>(() => focused.value || (innerValue.value !== null && innerValue.value !== undefined && innerValue.value !== ''));
</script>

<style lang="scss">

.dp__input {
  border: none;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --dp-font-family: 'Rubik', sans-serif;
  --dp-border-radius: 1rem;
  --dp-text-color: $text;
  --dp-input-padding: 1rem; /*Padding in the input*/

  &::placeholder {
    font-weight: 600;
    color: $text;
    opacity: 0.73;
    transition: all 135ms ease-in-out;
  }
}
</style>
